import React from 'react';
import { Target, Users, Handshake } from 'lucide-react';

const pillars = [
  {
    icon: Target,
    title: 'Lead Generation',
    text: 'We bring serious buyers through targeted campaigns and on-ground strategies.',
  },
  {
    icon: Users,
    title: 'Site Visit Conversion',
    text: 'Our team ensures every visit is handled professionally to maximize closures.',
  },
  {
    icon: Handshake,
    title: 'Deal Closure',
    text: 'From negotiation to booking — we drive results, not just inquiries.',
  },
];

const ValueProp = () => (
  <section className="bg-[#0a0a0a] py-24 sm:py-32" data-testid="value-prop-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <h2
        className="scroll-reveal text-3xl sm:text-4xl lg:text-[2.75rem] font-bold text-white text-center leading-tight tracking-tight mb-20"
        data-testid="value-prop-heading"
      >
        End-to-End Sales Execution{' '}
        <span className="bg-gradient-to-r from-white via-gray-300 to-gray-500 bg-clip-text text-transparent">
          for Builders
        </span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
        {pillars.map(({ icon: Icon, title, text }, i) => (
          <div
            key={title}
            className={`scroll-reveal stagger-${i + 1} group rounded-2xl border border-white/[0.06] bg-white/[0.02] p-10 transition-all duration-300 hover:bg-white/[0.05] hover:border-white/[0.12] hover:-translate-y-1`}
            data-testid={`value-card-${i}`}
          >
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white/[0.06] text-white/70 group-hover:text-white group-hover:bg-white/[0.10] transition-colors duration-300">
              <Icon className="w-6 h-6" strokeWidth={1.5} />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3 tracking-tight">{title}</h3>
            <p className="text-[15px] leading-relaxed text-gray-400">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ValueProp;
